import React from 'react';
import PropTypes from 'prop-types';

import {
  CardContent,
  Card,
  Collapse,
  Switch,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { withStyles } from '@material-ui/core/styles';

import CardTitle from 'components/CardTitle';

const AdditionalFeatureToggleButtons = ({
  title,
  copyAll,
  setCopyAll,
  children,
  classes,
  disabled,
  warning,
}) => (
  <Card>
    <CardContent className={classes.card}>
      <CardTitle className={classes.cardTitle}>
        <span className={classes.cardLabel}>
          {title}
        </span>

        <Switch
          checked={copyAll}
          onChange={() => setCopyAll(!copyAll)}
          color="primary"
          name="forms_all"
          disabled={disabled}
        />
      </CardTitle>

      {children && (
        <Collapse in={!copyAll}>
          <br />
          <div className={classes.formToggles}>
            {children}
          </div>
        </Collapse>
      )}
      {warning && (
        <Alert severity="warning" className={classes.warning}>
          {warning}
        </Alert>
      )}
    </CardContent>
  </Card>
);

AdditionalFeatureToggleButtons.propTypes = {
  title: PropTypes.string.isRequired,
  copyAll: PropTypes.bool.isRequired,
  setCopyAll: PropTypes.func.isRequired,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  warning: PropTypes.string,
};

const styles = (theme) => ({
  cardTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '0',
  },
  cardLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    fontWeight: '400',
    gap: '16px',
  },
  formToggles: {
    display: 'grid',
    justifyItems: 'start',
    gap: theme.spacing(1),
  },
  warning: {
    marginTop: theme.spacing(2),
  },
});

export default withStyles(styles)(AdditionalFeatureToggleButtons);
